// extracted by mini-css-extract-plugin
export var details = "_eb-0";
export var inspectorPopover = "_eb-1";